import { Fragment, useState } from 'react'
import { EuiButton } from '@equipmentshare/ds2'
import useProcessTransactionHandler from 'views/reports/effects/process-transaction'
import { getRefetchTransactionQueries } from 'views/reports/utils'

export const refetchQueries = [
	...getRefetchTransactionQueries(),
	'StoreParts',
]

export type ConfirmApprovalButtonsProps = {
	closePopover: () => void,
	transactionId: number,
}

export default function ConfirmApprovalButtons( { closePopover, transactionId }: ConfirmApprovalButtonsProps ) {
	const processTransaction = useProcessTransactionHandler( { refetchQueries } )
	const [ isSaving, setIsSaving ] = useState( false )

	const onApprove = () => {
		setIsSaving( true )
		processTransaction( transactionId )
			.catch( () => setIsSaving( false ) )
		closePopover()
	}

	return (
		<Fragment>
			<EuiButton
				color="text"
				onClick={closePopover}
			>
				Cancel
			</EuiButton>
			<EuiButton
				id="approve-btn"
				color="success"
				fill
				isLoading={isSaving}
				onClick={onApprove}
			>
				Approve
			</EuiButton>
		</Fragment>
	)
}
